import React from "react";
import BlueBtn from "../../BlueBtn/BlueBtn.module";
import styles from "./ViewSettings.module.css";
import { Link } from "react-router-dom";
const ViewSettings = ({ accountId }) => {
  return (
    <>
      <div className={styles.userActions}>
        {/* <div className={`${styles.label} ${styles.fuller} `}>
          <div className={styles.mkcol2}>
            <div>
              <i class="fa-solid fa-cog"></i>
              تنظیمات و اطلاعات
            </div>
          </div>
        </div> */}
        {/* <div className={styles.desc}>
          <i class="fal fa-exclamation-circle"></i>
          جهت تغییر کشور، اینترنت کودکان، و یا حالت Game Mode به تنظیمات مراجعه
          نمایید.
        </div> */}

        <Link to={"/account-settings/?account=" + accountId}>
          <BlueBtn icon="fa-solid fa-gear-complex" onAtion={() => {}}>
            تنظیمات و اطلاعات
          </BlueBtn>
        </Link>
      </div>
    </>
  );
};

export default ViewSettings;
